<div class="delete-dialog">
  <h1 class="title">{{ 'NEW_CONTRACTS.DELETE_DIALOG.TITLE' | i18nextEager }}</h1>
  <p class="text">{{ 'NEW_CONTRACTS.DELETE_DIALOG.TEXT' | i18nextEager }}</p>
  <span class="save">
    <input type="checkbox" [(ngModel)]="checked" (change)="onChecked($event)" />
    {{ 'NEW_CONTRACTS.DELETE_DIALOG.SAVE' | i18nextEager }}
  </span>
  <div class="buttons">
    <button class="secondary" (click)="cancel()">{{ 'COMMONS.CANCEL' | i18nextEager }}</button>
    <button class="primary" (click)="delete()">{{ 'NEW_CONTRACTS.DELETE_DIALOG.DELETE' | i18nextEager }}</button>
  </div>
</div>
